/**
 * Splash Page Component - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A comprehensive splash/landing page with advanced features:
 * - Welcome message for new portal users
 * - Interactive navigation tiles for easy portal access
 * - Dynamic navigation structure loading from JSON
 * - Clean and modern splash screen design
 * - Member onboarding and orientation
 * - Responsive navigation tile layout
 * - Portal introduction and guidance
 * 
 * Features:
 * - NavigationTiles component integration
 * - Dynamic navigation structure from JSON data
 * - Responsive design for various screen sizes
 * - Clean and welcoming user interface
 * - Portal orientation and guidance
 * - Tile-based navigation system
 * - Modern splash screen aesthetics
 * 
 * @returns {JSX.Element} Splash page component with navigation tiles and welcome content
 */
import React from 'react';
import './Splash.css';
import NavigationTiles from '../components/Dashboard/NavigationTiles';
import navigationStructure from '../data/navigationStructure.json';

/**
 * Splash component for portal landing page
 * with navigation tiles and welcome content
 */
const Splash = () => {

  return (
    <div className="container">
      <div className="splash-container">
        <div className="splash-content">
          <div className="splash-header">
            <div className="splash-content-message">  
              <h1 className="main-header">Welcome to the Member Portal</h1>
              <p>Please select a navigation option from the menu below to get started.</p>
            </div>


          </div>

          <NavigationTiles navigationStructure={navigationStructure} />
        </div>
      </div>
    </div>
  );
};

export default Splash; 